module.exports = __webpack_public_path__ + "img/beforeBind.47ee6380.png";